import { BankProfile } from '@otw/models';

/** Documentation fee included on retail order documents and companion PDF invoices */
export const RETAIL_ORDER_DOC_FEE = 398;

export type SaleDocumentMode = 'retail_order' | 'invoice_pdf' | 'down_payment_pdf';

export interface SaleInvoiceRecipient {
  email: string;
  first_name: string;
  last_name: string;
  company?: string;
  street_address?: string;
  city?: string;
  state?: string;
  postal_code?: string;
}

export interface PdfVehiclePricing {
  listPrice: number;
  shippingPrice: number;
}

export type ExtraLineItemType = 'charge' | 'deposit';

/** Optional order-level add-on or deposit included in PandaDoc / PDF totals */
export interface ExtraLineItem {
  label: string;
  /** Always positive; deposits subtract via type */
  amount: number;
  type: ExtraLineItemType;
}

export interface SaleInvoiceSubmitData {
  mode: SaleDocumentMode;
  bankAssignments: Array<{ vehicleIds: string[]; bankProfile: BankProfile }>;
  cashDealVehicleIds: string[];
  allVehicleIds: string[];
  separateCustomerInvoices: boolean;
  generateOdometerStatements: boolean;
  hideVins: boolean;
  /** PDF invoice-only: include documentary fee ($398 × vehicle count) */
  includeDocFee: boolean;
  shippingPrices: Record<string, number>;
  /** Valid additional line items (label + amount > 0); deposits reduce the total */
  extraLineItems: ExtraLineItem[];
  recipient: SaleInvoiceRecipient;
  pdfPricingByVehicleId: Record<string, PdfVehiclePricing>;
  downPaymentAmount: number;
}
